import { motion } from "framer-motion";
import { User } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const travelers = [
  {
    name: "Jade Ally",
    role: "Organizer",
    description: "Planning the perfect adventure for everyone.",
  },
  {
    name: "Aarin Jasikumar",
    role: "Photographer",
    description: "Capturing all the amazing moments.",
  },
  {
    name: "Jordan Ally",
    role: "The Chill Guy",
    description: "Always ready to relax and enjoy the moment.",
  },
  {
    name: "Avery Chan",
    role: "Foodie",
    description: "Discovering the best local cuisine.",
  },
  {
    name: "Shameer Ally",
    role: "Foodie",
    description: "Discovering the best local cuisine.",
  },
  {
    name: "Channa Say-Ally",
    role: "Foodie",
    description: "Discovering the best local cuisine.",
  },
];

const Travelers = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container max-w-6xl mx-auto">
        <AnimatedSection>
          <span className="text-primary font-medium tracking-widest uppercase text-sm">
            Our Group
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 mb-12">
            Meet the Travelers
          </h2>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {travelers.map((traveler, index) => (
            <AnimatedSection key={traveler.name} delay={index * 0.1}>
              <motion.div
                whileHover={{ y: -5, scale: 1.02 }}
                transition={{ duration: 0.3 }}
                className="glass-card rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300"
              >
                <div className="flex items-center justify-center mb-4">
                  <div className="p-4 rounded-full bg-primary/10">
                    <User className="w-8 h-8 text-primary" />
                  </div>
                </div>
                <h3 className="text-xl font-serif font-semibold mb-1">{traveler.name}</h3>
                <p className="text-sm text-primary font-medium mb-3">{traveler.role}</p>
                <p className="text-sm text-muted-foreground">{traveler.description}</p>
              </motion.div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Travelers;
